import type { LocalizedDict } from '../index'

type Strings = {
  title: string
  description: string
  on: string
  off: string
  loading: string
  permissionDenied: string
  loadError: string
  retry: string
  enable: string
  disable: string
  reviewTitle: string
  enableImpact: string
  disableImpact: string
  cancel: string
  confirmEnable: string
  confirmDisable: string
  saving: string
  saveError: string
}

export const problemReportingRolloutI18n: LocalizedDict<Strings> = {
  en: {
    title: 'Problem reporting',
    description: 'Control problem reporting across the Admin, Seller, and Supply panels. Reports and media remain private and subject to server permissions.',
    on: 'On',
    off: 'Off',
    loading: 'Loading problem reporting setting…',
    permissionDenied: 'You do not have permission to manage problem reporting.',
    loadError: 'The setting could not be read. Changes are unavailable until its state is known.',
    retry: 'Retry',
    enable: 'Enable problem reporting',
    disable: 'Disable problem reporting',
    reviewTitle: 'Review global problem reporting change',
    enableImpact: 'Enabling makes reporting available to all eligible Admin, Seller, and Supply users immediately. You can disable it here if acceptance fails.',
    disableImpact: 'Disabling immediately blocks new reports and uploads. Authorized users can still read existing reports and attachments; existing evidence is retained.',
    cancel: 'Cancel',
    confirmEnable: 'Confirm enable',
    confirmDisable: 'Confirm disable',
    saving: 'Saving…',
    saveError: 'The change could not be verified. Refresh the setting before another attempt.',
  },
  tr: {
    title: 'Hata bildirme',
    description: 'Admin, Satıcı ve Tedarikçi panellerinde hata bildirmeyi yönetir. Raporlar ve medya özel kalır; sunucu yetkileri uygulanır.',
    on: 'Açık',
    off: 'Kapalı',
    loading: 'Hata bildirme ayarı yükleniyor…',
    permissionDenied: 'Hata bildirmeyi yönetme yetkiniz yok.',
    loadError: 'Ayar okunamadı. Durumu bilinmeden değişiklik yapılamaz.',
    retry: 'Tekrar dene',
    enable: 'Hata bildirmeyi aç',
    disable: 'Hata bildirmeyi kapat',
    reviewTitle: 'Genel hata bildirme değişikliğini incele',
    enableImpact: 'Açıldığında hata bildirme tüm uygun Admin, Satıcı ve Tedarikçi kullanıcılarına anında sunulur. Kabul başarısızsa buradan kapatabilirsiniz.',
    disableImpact: 'Kapatıldığında yeni raporlar ve yüklemeler hemen engellenir. Yetkili kullanıcılar mevcut raporları ve ekleri okumaya devam edebilir; kanıtlar korunur.',
    cancel: 'İptal',
    confirmEnable: 'Açmayı onayla',
    confirmDisable: 'Kapatmayı onayla',
    saving: 'Kaydediliyor…',
    saveError: 'Değişiklik doğrulanamadı. Yeni bir denemeden önce ayarı tekrar okuyun.',
  },
}
